var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 8.10961L14.62 10.7496C14.8 11.1096 15.28 11.4696 15.68 11.5296L18.07 11.9296C19.6 12.1896 19.96 13.2896 18.86 14.3896L17 16.2496C16.69 16.5596 16.51 17.1696 16.61 17.6096L17.14 19.9196C17.56 21.7396 16.59 22.4496 14.98 21.4996L12.74 20.1696C12.33 19.9296 11.67 19.9296 11.26 20.1696L9.01996 21.4996C7.40996 22.4496 6.43995 21.7396 6.85995 19.9196L7.38998 17.6096C7.48998 17.1796 7.30997 16.5696 6.99997 16.2496L5.13998 14.3896C4.03998 13.2896 4.39996 12.1796 5.92996 11.9296L8.31997 11.5296C8.71997 11.4596 9.19997 11.1096 9.37997 10.7496L10.7 8.10961C11.41 6.67961 12.59 6.67961 13.3 8.10961Z",
    stroke: "#DE9C27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9V2",
    stroke: "#DE9C27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9V2",
    stroke: "#DE9C27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4V2",
    stroke: "#DE9C27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.1ae1c76082e9b556b2d17c2daf7a9be3.svg";
export { ForwardRef as ReactComponent };